<template>
  <div class="login-style">
    <b-modal
      visible
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      content-class="rounded-xl"
    >
      <b-overlay
        :show="isLoading"
        rounded="xl"
        variant="transparent"
        blur="2px"
      >
        <template #overlay>
          <lottie-loading></lottie-loading>
        </template>
        <div class="d-flex flex-column align-items-center">
          <!--begin::Logo-->
          <router-link :to="{ path: '/login' }" class="text-center">
            <img :src="$_config.logo.lg" alt="Logo" class="max-h-150px" />
          </router-link>
          <!--end::Logo-->
          <!--begin::Form-->

          <form
            @submit="loginState($event)"
            class="mt-5 w-100"
            novalidate="novalidate"
            id="kt_login_signin_form"
          >
            <!--begin::Title-->
            <div class="pb-5">
              <h2
                class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg"
              >
                Log In
              </h2>
              <p class="text-muted">
                Enter your email and password to login our dashboard
                {{ $_config.name }}
                {{ $_config.company }}
              </p>
            </div>
            <!--end::Title-->
            <!--begin::Form group-->
            <div class="form-group fv-plugins-icon-container has-success">
              <label class="font-size-h6 font-weight-bolder text-dark">
                <i class="ri-mail-line"></i> Email
              </label>
              <input
                v-model.lazy.trim="email"
                class="form-control form-control-solid h-auto py-7 px-6 rounded-pill"
                type="email"
                name="email"
                autocomplete="off"
                placeholder="Type email here ..."
              />
              <div class="fv-plugins-message-container"></div>
            </div>
            <!--end::Form group-->
            <!--begin::Form group-->
            <div class="form-group fv-plugins-icon-container has-success">
              <div class="d-flex justify-content-between mt-n5">
                <label class="font-size-h6 font-weight-bolder text-dark pt-5">
                  <i class="ri-key-line"></i> Password
                </label>
                <a
                  v-if="$_config.options.forgetPassword"
                  @click="state = 'forgot'"
                  class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5 pointer"
                  id="kt_login_forgot"
                  >Lupa Password ?</a
                >
              </div>
              <input
                v-model.lazy.trim="password"
                class="form-control form-control-solid h-auto py-7 px-6 rounded-pill"
                type="password"
                name="password"
                autocomplete="off"
                placeholder="Type password here ..."
              />
              <div class="fv-plugins-message-container"></div>
            </div>
            <!--end::Form group-->
            <div
              v-if="errorLogin"
              class="alert alert-custom alert-default p-2"
              role="alert"
            >
              <div class="alert-icon">
                <i class="ri-error-warning-fill text-danger"></i>
              </div>
              <div class="alert-text">
                {{ errorLogin }}
                <p class="mt-3 mb-0" v-if="showResendEmail">
                  Belum mendapat email Verifikasi? <br /><a
                    class="text-primary pointer"
                    @click="resendVerification()"
                    >Kirim ulang
                    <span v-if="resendWaiting > 0">({{ resendWaiting }})</span>
                  </a>
                </p>
              </div>
            </div>
            <!--begin::Action-->
            <div class="text-center pt-2">
              <b-btn
                id="kt_login_signin_submit"
                block
                type="submit"
                class="pointer font-weight-bolder font-size-h6 px-8 py-4 my-3 rounded-pill"
              >
                <b-spinner v-if="isLoading" variant="white" small></b-spinner>
                Log In
              </b-btn>
            </div>
          </form>

          <!--end::Form-->
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "login-page",
  data() {
    return {
      state: "signin",
      email: "",
      password: "",
      errorLogin: null,
      forgetEmail: null,
      showResendEmail: false,
      tmp_user: null,
      resendWaiting: 0,
      isLoading: false,
    };
  },
  methods: {
    loginState(e) {
      e.preventDefault();
      if (this.email && this.password) {
        let data = { email: this.email, password: this.password };
        this.isLoading = true;
        this.$_api
          .post("/login", data)
          .then((res) => {
            this.isLoading = false;
            if (res) this.saveProfile(res);
            else this.actionUser(res.data_user_before_login, res.message);
          })
          .catch((err) => {
            this.isLoading = false;
            this.errorLogin = err.data.message;
            let msg = JSON.parse(err.data.message);
            this.errorLogin = msg.errorMessage;
          });
        this.errorLogin = null;
      } else {
        this.errorLogin = "Email & Password harus diisi";
      }
    },
    actionUser(data, message) {
      this.tmp_user = data;
      if (data.status_code === "email_unverified") {
        this.showResendEmail = true;
        this.errorLogin = message;
      } else if (data.status_code === "email_verified") {
        this.$router.push({ name: "waiting-apps", params: { user: data } });
      }
    },
    resendVerification() {
      if (this.resendWaiting === 0) {
        this.$_api
          .post("/request_email_verification", this.tmp_user)
          .then((res) => {
            this.resendWaiting = 60;
            this.setWaiting();
          })
          .catch((err) => {
            this.errorLogin = err.data.message;
          });
      }
    },
    setWaiting() {
      setTimeout(() => {
        if (this.resendWaiting > 0) {
          this.resendWaiting--;
          this.$nextTick();
          this.setWaiting();
        }
      }, 1000);
    },
    async saveProfile(e) {
      this.$store.commit("set", ["profile", e.user, true]);
      this.$store.commit("set", ["_token", e.token, true]);
      this.$store.commit("set", ["permission", e.tasks, true]);
      await this.$store.dispatch("setModule");
      this.$router.push({ name: "main-module" });
    },
    forgetPassword() {
      this.$_api
        .post("/request_forgot_password", { email: this.forgetEmail })
        .then((res) => {
          this.forgetEmail = null;
          this.state = "forgot-success";
        })
        .catch((err) => {
          this.errorLogin = err.data.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-style {
  background-image: url("https://images7.alphacoders.com/895/895992.jpg");
  min-width: 100vw;
  min-height: 100vh;
  background-size: cover;
  background-position: left bottom;
  background-repeat: no-repeat;
  background-color: #e6d3af;
}
</style>



// WEBPACK FOOTER //
// src/default-page/login.vue